import React from 'react';

import { Content } from './Content.js';

export default class StyledTextBox extends React.Component {

  render() {
    return (
      <div className={`StyledTextBox row`}>
        <div className="col-xs-16" data-scroll-item-once>
          <div className="small-title">{Content[this.props.page].title}</div>
          <p>{Content[this.props.page].body}</p>
        </div>
      </div>
    );
  }

};
